import { useGetBuyerDetails } from '@/hooks/buyers/useGetBuyerDetails';
import { buyerDetailsResponseToPaymentDataUi } from '@/hooks/buyers/useGetBuyerDetails/mapper';
import { useSetTrustedUser } from '@/hooks/buyers/useSetTrustedUser';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { initialState, PaymentDataUi } from './PaymentDataUi';

export function usePaymentDataViewController() {
  const [uiState, setUiState] = useImmer<PaymentDataUi>(initialState);
  const buyerId = useParams().buyerId;
  const { data: buyerDetails } = useGetBuyerDetails(buyerId);
  const updateTrustedUser = useSetTrustedUser();

  useEffect(() => {
    if (!buyerDetails) return;
    setUiState(buyerDetailsResponseToPaymentDataUi(buyerDetails));
  }, [buyerDetails]);

  const onChangeEnableAllPaymentMethods = (newValue: boolean) => {
    if (!buyerId) return;
    updateTrustedUser.mutate({ userId: buyerId, trusted: newValue });
  };

  return {
    uiState,
    actions: {
      onChangeEnableAllPaymentMethods,
    },
  };
}
